<template>
  <div class="IncreaseCountry">
    <el-dialog
      title="添加国家"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="beforeCloseComponents"
    >
      <el-form
        class="custom-formItem"
        ref="formData"
        label-width="100px"
        inline
        :model="formData"
        :rules="rulesFormData"
      >
        <el-form-item label="国家" prop="countryName">
          <el-input v-model="formData.countryName" placeholder="请输入国家名称"></el-input>
        </el-form-item>
        <el-form-item label="国家简称" prop="countryCode">
          <el-input v-model="formData.countryCode" placeholder="请输入国家简称"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" @click="handleIncrease" :loading="loadingIncrease">添加</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="listTable" border size="small">
        <el-table-column prop="countryName" align="center" label="国家名称"></el-table-column>
        <el-table-column prop="countryCode" align="center" label="国家简称"></el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
  name: 'IncreaseCountry',
  data() {
    const validCountryCode = (rule, value, callback) => {
      const result = /^[A-Z]+$/g.test(value)
      if (!result) {
        callback(new Error('请输入正确的国家简称'));
      } else {
        callback();
      }
    }
    return {
      dialogVisible: false,
      formData: {
        countryName: '',
        countryCode: ''
      },
      rulesFormData: {
        countryName: [
          { required: true, message: '请输入国家名称', trigger: 'blur' }
        ],
        countryCode: [
          { validator: validCountryCode, required: true, trigger: 'blur' }
        ]
      },
      listTable: [],
      loadingIncrease: false
    }
  },
  methods: {
    initComponents() {
      this.dialogVisible = true

      this.getListTable()
    },
    beforeCloseComponents(done) {
      this.loadingIncrease = false
      this.$refs.formData.resetFields()
      this.$refs.formData.clearValidate()
      done()
    },
    handleIncrease() {
      this.$refs.formData.validate((valid) => {
        if (!valid) return
        const API = Baseurl + 'logisticsConfigurationController/insertLogisticsCountry'
        const paramsData = this.formData
        this.loadingIncrease = true

        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          this.loadingIncrease = false
          if (code === 200) {
            this.$refs.formData.resetFields()
            this.$message.success('操作成功！')
            this.getListTable()
          }
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该国家数据吗？', '提示')
        .then(() => {
          const API = Baseurl + 'logisticsConfigurationController/deleteLogisticsCountry'
          const paramsData = {
            id: row.id
          }

          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data
            if (code === 200) {
              this.$message.success('操作成功！')
              this.getListTable()
            } else if (code === 500) {
              this.$message.error(data)
            } else {
              this.$message.error('操作失败！')
            }
          })
        })
    },
    getListTable() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsCountryList'

      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data
        }
      })
    }
  }
}
</script>
